import { ModalEditPrinterSettings } from './ModalEditPrinterSettings'

export default ModalEditPrinterSettings
